
const fetchWithAuth = async (url, user, userPermissions, options = {}) => {
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (user && user.credential) {
    headers['Authorization'] = `Bearer ${user.credential}`;
  }

  if (userPermissions) {
    headers['X-User-Permissions'] = JSON.stringify(userPermissions);
  }

  const response = await fetch(url, {
    ...options,
    headers,
  });

  return response;
};

export default fetchWithAuth;
